exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".privacy_p[data-v-dbbebf62] {\n  padding: 2rem 5rem;\n  line-height: 18px;\n  color: #666;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 100vw;\n  min-height: calc(100vh - 60px);\n}\n.privacy_p h2[data-v-dbbebf62] {\n  text-align: center;\n}\n.privacy_p b[data-v-dbbebf62] {\n  display: block;\n  margin: 0.5rem 0;\n}\n.privacy_p span[data-v-dbbebf62] {\n  display: block;\n  padding: 10px 0 20px 0;\n  width: 100%;\n  overflow: hidden;\n  white-space: pre-wrap;\n}\n", ""]);

// exports
